import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { JobPhaseGarageDto } from './job-phase-garage.dto';
import { JobPhaseGarageCreatableInterface } from '../interfaces/job-phase-garage-creatable.interface';

export class JobPhaseGarageCreateDto
  extends IntersectionType(
    PickType(JobPhaseGarageDto, [
      'boardTypeId',
      'contractorId',
      'completionDate',
      'jobPhaseId',
      'quantity',
    ]),
    PartialType(
      PickType(JobPhaseGarageDto, ['approvedGeo', 'approvedGeoAccuracy']),
    ),
  )
  implements JobPhaseGarageCreatableInterface {}
